import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SelectBoxSmall from '../../common/SelectBox/SelectBoxSmall';
import InputBoxSmall from '../../common/InputBox/InputBoxSmall';
import CloseButton from '../../common/CloseButton/CloseButton';
import { isNumberOnly, isRequired} from '../../../validation';
import UploadBoxCountry from '../../common/InputBox/UploadCountry';
import InputAndSelectCompoBoxSmall from '../../common/InputBox/InputAndSelectCompo';
import EditUploadBoxCountry from '../../common/InputBox/EditUpload';
import { baseurl } from '../../../api';
import { fetchActiveCountryCode, fetchActiveLanguages, fetchTimezone } from '../../../services/Localization/CountryService';
import { fetchActiveUserRoles } from '../../../services/Settings/InternalUserService';
import SearchSelectBoxDrown from '../../common/SelectBox/searchSelect';


const InternalUserPopup = ({ isOpen, mode, buttonName, defaultValue, onSave, onClose, popupErrorMessage }) => {

  const [formValues, setFormValues] = useState([defaultValue]);
  const [editedData, setEditedData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [countries, setCountries] = useState([]);
  const [languages, setLanguages]= useState([]);
  const [UserRoles, setUserRole] = useState([]);
  const [timeZone, setTimezone] = useState([]);

  useEffect(() => {
    setFormValues(defaultValue)
  }, [defaultValue])

  // useEffect(() => {
  //   console.log("form", formValues)
  // }, [formValues])

  // useEffect(() => {
  //   console.log("Edited Data", editedData)
  // }, [editedData])

  useEffect(() => {
    if (!isOpen) {
      setFormValues({});
      setFormErrors({});
      setEditedData({});
    }
  }, [isOpen]);

  useEffect(() => {
    async function loadInitialData() {
        const [
        countriesData,
        userRolesData,
        timezonesData,
        languagesData
        ] = await Promise.all([
        fetchActiveCountryCode(),
        fetchActiveUserRoles(),
        fetchTimezone(),
        fetchActiveLanguages()
        ]);

        setCountries(countriesData);
        setUserRole(userRolesData);
        setTimezone(timezonesData);
        setLanguages(languagesData);
    }
    loadInitialData();
    }, []);


  if (!isOpen) return null;

  const handleInputChange = (field, value) => {
    setFormValues(prev => ({
      ...prev,
      [field]: value,
    }));

     // Track edited fields only in edit mode
    if (mode === 'edit' && defaultValue[field] !== value) {
      setEditedData(prev => ({
        ...prev,
        [field]: value,
      }));
    } else if (mode === 'edit' && defaultValue[field] === value) {
      // Remove from edited data if value matches original
      setEditedData(prev => {
        const newData = { ...prev };
        delete newData[field];
        return newData;
      });
    }

    if (formErrors[field]) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const formSchema = [
    { name: 'full_name', validators: [isRequired] },
    { name: 'email', validators: [isRequired] },
    { name: 'phone', validators: [isRequired] },
    { name: 'country_code', validators: [isRequired] },
    { name: 'role', validators: [isRequired] },
    { name: 'preferred_language', validators: [isRequired] },
    { name: 'timezone', validators: [isRequired] },
    { name: 'password', validators: [isRequired] },
    { name: 'cnf_password', validators: [isRequired] },
  ];

  const validateForm = () => {
    const errors = {};
    const dataToValidate = mode === 'edit' ? editedData : formValues;
    const fieldsToValidate = mode === 'edit' ? Object.keys(editedData) : formSchema.map(f => f.name);

    fieldsToValidate.forEach(fieldName => {
      const fieldSchema = formSchema.find(f => f.name === fieldName);
      if (!fieldSchema) return;

      const value = dataToValidate[fieldName] ?? '';

      for (const validator of fieldSchema.validators || []) {
        const result = validator(value);

        if (result === false || (typeof result === 'string' && result.length > 0)) {
          errors[fieldName] = typeof result === 'string' ? result : `${fieldName} is invalid`;
          break; // Stop at first error
        }
      }
    });

    // Override error for cnf_password if password and cnf_password mismatch
    const password = dataToValidate['password'];
    const cnfPassword = dataToValidate['cnf_password'];

    if (password !== undefined && cnfPassword !== undefined && password !== cnfPassword) {
      errors['cnf_password'] = "Password doesn't match";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const handleSubmit = () => {
    const isValid = validateForm();

    if (!isValid) {
      return;
    }
    const dataToSend = mode === 'edit' ? editedData : formValues;
    onSave(dataToSend);
  };

  const handleClose = () => {
    setFormValues({});
    setFormErrors({});
    setEditedData({});
    if (onClose) onClose();
  };
         
  return (
    <div className="popup-overlay">
      <div className="popup add-popup popup1">
        <CloseButton onClick={handleClose}  />
        {popupErrorMessage && (
          <div className="popup-error-message" style={{ color: 'red', marginBottom: '10px' }}>
            {popupErrorMessage}
          </div>
        )}
        <div className="popup-name-button">
          <h2 className="popup-name fts-17 common-text ftw-5 black">
            { mode === 'edit' ? 'Edit User' : 'Add User'}
          </h2>

          <button
            className="popup-add-button common-text white fts-15 ftw-5"
            onClick={handleSubmit}
          >
            {buttonName}
          </button>
        </div>
        <div className="add-input-box-container ai-center">
          <div className="field-container w-50">
              <InputBoxSmall
              label="User Name"
              validators={isRequired}
              defaultValue={formValues?.full_name}
              onChange={(e) => handleInputChange("full_name", e.target.value)}
              error={formErrors.full_name}
              />
          </div>
          <div className="field-container w-50">
            <InputBoxSmall
              label="Email"
              validators={isRequired}
              defaultValue={formValues?.email}
              error={formErrors.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
            />
          </div>
          <div className="field-container w-50">
            <InputAndSelectCompoBoxSmall
              label="Mobile Number"
              options={countries}
              validators={[isRequired,isNumberOnly]}
              defaultOption={formValues?.country_code?.id}
              defaultValue= {formValues?.phone}
              error={formErrors?.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              selectchange={(e) => handleInputChange("country_code", e.target.value)}
            />
          </div>
          <div className="field-container w-50">
            <SearchSelectBoxDrown
              label="User Role"
              options={UserRoles}
              validators={isRequired}
              defaultValue={formValues?.role?.id}
              error={formErrors.role}
              onChange={(e) => handleInputChange("role", e.target.value)}
            />
          </div>
          <div className="field-container w-50">
            <SearchSelectBoxDrown
              label="Preferred Language"
              options={languages}
              validators={isRequired}
              defaultValue={formValues?.preferred_language?.id}
              error={formErrors.preferred_language}
              onChange={(e) => handleInputChange("preferred_language", e.target.value)}
            />
          </div>
          <div className="field-container w-50">
            <SearchSelectBoxDrown
              label="User Time Zone "
              validators={isRequired}
              options={timeZone}
              defaultValue={formValues?.timezone}
              error={formErrors.timezone}
              onChange={(e) => handleInputChange("timezone", e.target.value)}
            />
          </div>
          {mode !=='edit' && (
            <>
              <div className="field-container w-50">
                <InputBoxSmall
                  label="Password"
                  type="password"
                  validators={isRequired}
                  error={formErrors.password}
                  onChange={(e) => handleInputChange("password", e.target.value)}
                />
              </div>
              <div className="field-container w-50">
                <InputBoxSmall
                  label="Confirm Password"
                  type="password"
                  validators={isRequired}
                  cnf_password={formValues?.password}
                  error={formErrors.cnf_password}
                  onChange={(e) => handleInputChange("cnf_password", e.target.value)}
                />
              </div>
            </>
          )}
          {mode !== 'edit' ? (
            <UploadBoxCountry
              label="Profile Picture"
              onFileChange={(file) => handleInputChange("profile_pic", file)}
            />
          ) : (
            <EditUploadBoxCountry 
              label="Profile Picture"
              existingImage={
                formValues?.profile_pic
                  ? `${baseurl.replace(/\/$/, '')}${formValues.profile_pic}`
                  : "/assets/avatar.jpg"
              }
              onFileChange={(file) => handleInputChange("profile_pic", file)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

InternalUserPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  mode: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default InternalUserPopup;